import { makeStyles } from "@material-ui/core/styles";

export default function PagamentosListaCss() {
    return makeStyles((theme) => ({
        card: {
            minWidth: 275,
            marginBottom: 20,
            padding: "12px",
            display: "flex",
        },
        img: {
            flex: "1 1 auto",
            maxWidth: "70px",
            maxHeight: "60px",
        },
        Description: {
            color: theme.palette.text.secondary,
        },
        title: {
            fontSize: 20,
            fontWeight: "bold",
        },
        subTitle: {
            fontSize: 14,
        },
    }));
}
